import { handleError } from "@/api/handleError";
import { IS_PROD, trackAmplitudeEvent } from "@/helpers";
import { AMPLITUDE_EVENTS } from "@/helpers/integrations/analytics/events";
import { useCustomerIO } from "./useCustomerIO";

const useAnalytics = () => {
  const customerIO = useCustomerIO();

  const logEvent = async (
    event: AMPLITUDE_EVENTS | string,
    props?: Record<string, string | boolean | number | Date | undefined | null>,
    shouldForceTrack?: boolean
  ) => {
    try {
      await Promise.all([
        trackAmplitudeEvent(event, props, shouldForceTrack),
        ...(IS_PROD && shouldForceTrack
          ? [customerIO.track(event, props)]
          : []),
      ]);
    } catch (error) {
      handleError({ error, silent: true });
    }
  };

  return { logEvent, customerIO };
};

export default useAnalytics;
